import { useState } from 'react';
import { API_URL } from '@constants';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';

const ENDPOINT_URL = '/cfg-system-settings/banner_custom_alert';

export interface BannerCustomAlert {
    content_banner_custom_alert_subtitle: string | null;
    content_banner_custom_alert_title: string | null;
    content_banner_custom_alert_description: string | null;
    content_banner_custom_alert_button_text: string | null;
    content_banner_custom_alert_link: string | null;
    content_banner_custom_alert_image: string | null;
}

export interface GetBannerCustomAlertSuccessResponse {
    data: BannerCustomAlert;
    success: boolean;
    message: string;
}

export const useGetBannerCustomAlert = () => {
    const { getHeaders, getCommonParameters, handleCommonErrors } = useApiConfig();
    const [banner, setBanner] = useState<BannerCustomAlert | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const request = async () => {
        setLoading(true);
        setError(null);

        try {
            const inputParameters = new URLSearchParams(getCommonParameters()).toString();

            const response = await fetch(`${API_URL}${ENDPOINT_URL}?${inputParameters}`, {
                method: 'GET',
                headers: getHeaders(),
            });

            if (!response.ok) {
                const json = await response.json();
                const error = new Error(json.error || json.message || 'Erro ao buscar banner custom alert') as ApiError;
                error.statusCode = response.status;
                throw error;
            }

            const result: GetBannerCustomAlertSuccessResponse = await response.json();

            setBanner(result.data);
        } catch (err: any) {
            handleCommonErrors(err);
            setError(err.message || 'Erro ao buscar banner custom alert');
        } finally {
            setLoading(false);
        }
    };

    return { banner, request, loading, error };
};
